import { getInvitation } from "../api_getInvitation.js";

export function handleSaveResponse(response, dynamicValue, { dimmed, toggleElements, scrollPreventEvent, deleteBtn } = {}) {
    console.log(response);

    let myPageURL = `/mypage`;

    let previewButton = document.getElementById('previewInvitation');
    let savedViewButton = document.getElementById('SavedView');
    
    // savedViewButton 이벤트 리스너 처리
    if (savedViewButton && !savedViewButton.dataset.listenerAdded) {
        const handleSavedViewClick = () => {
            if (myPageURL) {
                window.open(`/mypage`, '_blank');
            } else {
                console.log('실패');
            }
        };
        
        savedViewButton.addEventListener('click', handleSavedViewClick);
        savedViewButton.dataset.listenerAdded = 'true';
    }

    // previewButton 이벤트 리스너 처리
    if (previewButton && !previewButton.dataset.listenerAdded) {
        const handlePreviewClick = () => {
            getInvitation(dynamicValue)
            .then(html => {
                // 새 창으로 경로 이동
                window.open(`/api_GetInvitation/${dynamicValue}`, '_blank');
            })
            .catch(error => {
                console.error('Error:', error);
            });
        };
        
        previewButton.addEventListener('click', handlePreviewClick);
        previewButton.dataset.listenerAdded = 'true';
    }

    if (dimmed) {
        dimmed.addEventListener('click', toggleElements);
        scrollPreventEvent.style.overflowY = 'hidden';
    }
    if (deleteBtn) {
        deleteBtn.addEventListener('click', toggleElements);
        scrollPreventEvent.style.overflowY = 'hidden';
    }
}
